<template>
<div class="odr-row"
     :class="{
         'odr-row_adaptive': adaptive === 'true',
         'odr-row_border': border === 'true',
         'odr-row_table': table === 'true',
     }">
    <slot></slot>
</div>
</template>
<script>
import '../styles/row.scss'

export default {
    props: {
        border: {
            type: String,
            _descr: 'Add border on ceiling',
        },
        adaptive: {
            type: String,
            _descr: 'Allow columns to wrap',
        },
        table: {
            type: String,
            _descr: 'Align columns between sibling rows',
        },
    },
}
</script>
